import { useTranslation } from "react-i18next";
import DataListItemText from "./DataListItemText";
import { DeviceStatus } from "@/gql/graphql";
import type { DeviceStatusNotificationData } from "../types/deviceNotification.types";

type DeviceStatusNotificationProps = {
  data: DeviceStatusNotificationData;
};

const DeviceStatusNotifications = (props: DeviceStatusNotificationProps) => {
  const { data } = props;
  const { deviceStatusSerialNumber, deviceStatus } = data;
  const { t } = useTranslation();

  const isBlocked = deviceStatus?.toUpperCase() === DeviceStatus.Blocked;
  const deviceId = deviceStatusSerialNumber ?? "";

  return (
    <DataListItemText
      primary={t(
        isBlocked
          ? "notifications.blocked_device.title"
          : "notifications.unblocked_device.title",
        {
          deviceId,
        }
      )}
      secondary={t(
        isBlocked
          ? "notifications.blocked_device.description"
          : "notifications.unblocked_device.description",
        {
          name: deviceId,
        }
      )}
    />
  );
};

export default DeviceStatusNotifications;
